import * as React from 'react';
import UserMiniProfile from '../UserMiniProfile';

const MultipleMiniProfile = (props) => {
    if(props.data.length > 0){
        return <div className="exz-userminiprofile-container rowFlex"> {props.data.map((item,key) => <UserMiniProfile userId={item.id} type={item.type} wklocation={props.wklocation} title={item.title} key={key} isMultipleProfile={true}/>)}</div>
    }
    return null;
};

export default MultipleMiniProfile;
